// import React, { useState, useEffect } from "react";
// import "./tenantmodal.css"; // Ensure you have this CSS file
// import { IoIosCloseCircleOutline } from "react-icons/io";

// function TenantModal({
//   show,
//   handleClose,
//   tenantData,
//   selectedTenantId,
//   handleApply,
// }) {
//   const [localSelectedTenantId, setLocalSelectedTenantId] =
//     useState(selectedTenantId);

//   useEffect(() => {
//     setLocalSelectedTenantId(selectedTenantId);
//   }, [selectedTenantId]);

//   if (!show) {
//     return null;
//   }

//   const handleTenantChange = (tenantId) => {
//     setLocalSelectedTenantId(tenantId);
//     console.log("Tenant selected:", tenantId);

//   };

//   const handleApplyClick = () => {
//     handleApply(localSelectedTenantId);
//     console.log("Tenant Apply Btn clicked", localSelectedTenantId);
//     handleClose();
//   };

//   return (
//     <div className="modal-tenant">
//       <div className="modal-content-tenant">
//         <IoIosCloseCircleOutline
//           style={{ float: "right", cursor: "pointer" }}
//           onClick={handleClose}
//           size={30}
//         />
//         <h2>Select a Tenant</h2>
//         <ul>
//           {tenantData.map((tenant) => (
//             <li key={tenant.tenant_id}>
//               <label>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "start",
//                     justifyContent: "space-between",
//                     gap: "5px",
//                     padding: "10px",
//                   }}
//                 >
//                   <div>
//                     {tenant.is_primary ? (
//                        <>
//                        <p style={{ fontSize: "15px" }}>
//                          {tenant.first_name} {tenant.last_name}
//                        </p>
//                        <p style={{ fontSize: "10px" }}>
//                          {tenant.building_name}
//                        </p>
//                      </>

//                     ):(
//                       <>

//                       </>
//                     )}
//                   </div>
//                   <div>
//                     <input
//                       type="radio"
//                       name="tenant"
//                       value={tenant.tenant_id}
//                       checked={localSelectedTenantId === tenant.entity_id}
//                       onChange={() => handleTenantChange(tenant.entity_id)}
//                     />
//                   </div>
//                 </div>
//               </label>
//             </li>
//           ))}
//         </ul>
//         <button onClick={handleApplyClick} disabled={false}>
//           Apply
//         </button>
//       </div>
//     </div>
//   );
// }

// export default TenantModal;

// import React, { useState, useEffect } from "react";
// import "./tenantmodal.css"; // Keep this if you have specific tenant modal styles
// import { IoIosCloseCircleOutline } from "react-icons/io";

// function TenantModal({
//   show,
//   handleClose,
//   tenantData,
//   selectedTenantIds,
//   handleApply,
// }) {
//   const [localSelectedIds, setLocalSelectedIds] = useState([]);
//   const [searchQuery, setSearchQuery] = useState(""); // New state for search query

//   useEffect(() => {
//     if (show) {
//       setLocalSelectedIds(selectedTenantIds || []);
//       setSearchQuery(""); // Clear search query when modal opens
//     }
//   }, [show, selectedTenantIds]);

//   if (!show) {
//     return null;
//   }

//   const handleTenantChange = (tenantId) => {
//     setLocalSelectedIds((prevIds) => {
//       if (prevIds.includes(tenantId)) {
//         return prevIds.filter((id) => id !== tenantId);
//       } else {
//         return [...prevIds, tenantId];
//       }
//     });
//   };

//   const handleApplyClick = () => {
//     handleApply(localSelectedIds);
//     handleClose();
//   };

//   // Filter the tenantData to only include primary tenants
//   const primaryTenants = (tenantData || []).filter(
//     // Ensure tenantData is an array
//     (tenant) => tenant.is_primary === true
//   );

//   // Filter primary tenants based on search query
//   const filteredTenants = primaryTenants.filter((tenant) => {
//     const searchLower = searchQuery.toLowerCase();
//     const firstNameLower = (tenant.first_name || "").toLowerCase();
//     const lastNameLower = (tenant.last_name || "").toLowerCase();
//     const buildingNameLower = (tenant.building_name || "").toLowerCase();
//     const mobileLower = (tenant.mobile || "").toLowerCase(); // Ensure mobile is handled if it can be null/undefined

//     return (
//       firstNameLower.includes(searchLower) ||
//       lastNameLower.includes(searchLower) ||
//       buildingNameLower.includes(searchLower) ||
//       mobileLower.includes(searchLower)
//     );
//   });

//   const handleSelectAll = () => {
//     setLocalSelectedIds(filteredTenants.map((tenant) => tenant.entity_id));
//   };

//   const handleClearAll = () => {
//     setLocalSelectedIds([]);
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 h-[80vh] flex flex-col">
//         {/* Fixed Header */}
//         <div className="flex-shrink-0 flex items-center justify-between p-4 border-b border-gray-200">
//           <h2 className="text-lg font-semibold text-gray-800">
//             Select Tenants
//           </h2>
//           <button
//             onClick={handleClose}
//             className="text-gray-400 hover:text-gray-600 transition-colors"
//           >
//             <IoIosCloseCircleOutline size={30} />
//           </button>
//         </div>

//         {/* Search Input Field */}
//         <div className="flex-shrink-0 p-4 border-b border-gray-100">
//           <input
//             type="text"
//             placeholder="Search tenants by name, building, or mobile..."
//             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//         </div>

//         {/* Actions Bar (Fixed) */}
//         <div className="flex-shrink-0 flex items-center justify-between p-4 border-b border-gray-100 bg-gray-50">
//           <span className="text-sm text-gray-600">
//             {localSelectedIds.length} of {filteredTenants.length} visible
//             tenants selected
//           </span>
//           <div className="flex gap-2">
//             <button
//               onClick={handleSelectAll}
//               className="text-sm text-blue-600 hover:text-blue-800 font-medium"
//             >
//               Select All
//             </button>
//             <span className="text-gray-300">|</span>
//             <button
//               onClick={handleClearAll}
//               className="text-sm text-red-600 hover:text-red-800 font-medium"
//             >
//               Clear All
//             </button>
//           </div>
//         </div>

//         {/* Scrollable Content */}
//         <div className="flex-1 overflow-y-auto p-4">
//           {filteredTenants.length > 0 ? (
//             // 🔥 CORRECTED SYNTAX: Added curly braces around the JSX block
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//               {filteredTenants.map((tenant) => (
//                 <label
//                   key={tenant.entity_id} // Consistency: using entity_id for key
//                   className="flex items-center p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors"
//                 >
//                   <input
//                     type="checkbox"
//                     className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
//                     checked={localSelectedIds.includes(tenant.entity_id)}
//                     onChange={() => handleTenantChange(tenant.entity_id)}
//                   />
//                   <div className="ml-3 flex-1">
//                     <div className="font-medium text-gray-900">
//                       {tenant.first_name} {tenant.last_name}
//                     </div>
//                     <div className="text-sm text-gray-500">
//                       {tenant.building_name}
//                     </div>
//                   </div>
//                   {localSelectedIds.includes(tenant.entity_id) && (
//                     <div className="ml-2 text-blue-600">
//                       {/* 🔥 Added key prop to SVG for list rendering best practice */}
//                       <svg
//                         key={`checkmark-${tenant.entity_id}`}
//                         className="w-5 h-5"
//                         fill="currentColor"
//                         viewBox="0 0 20 20"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                     </div>
//                   )}
//                 </label>
//               ))}
//             </div>
//           ) : (
//             <div className="flex flex-col items-center justify-center py-12 text-gray-500">
//               <svg
//                 className="w-12 h-12 mb-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                 />
//               </svg>
//               <p className="text-sm">
//                 {searchQuery
//                   ? "No tenants found matching your search."
//                   : "No tenants available."}
//               </p>
//             </div>
//           )}
//         </div>

//         {/* Fixed Footer */}
//         <div className="flex-shrink-0 p-4 border-t border-gray-200 bg-gray-50">
//           <div className="flex gap-3">
//             <button
//               onClick={handleClose}
//               className="flex-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 font-medium transition-colors"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleApplyClick}
//               className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//               disabled={localSelectedIds.length === 0}
//             >
//               Apply ({localSelectedIds.length})
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TenantModal;

import React, { useState, useEffect } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FaCheckCircle, FaUsers } from "react-icons/fa"; // Added relevant icons

// A simple utility component for circular initials, can be moved to its own file later.
const CircularInitial = ({ name }) => {
  const initial = name ? name.charAt(0).toUpperCase() : "?";
  return (
    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-blue-500 text-white rounded-full font-semibold text-lg">
      {initial}
    </div>
  );
};

function TenantModal({
  show,
  handleClose,
  tenantData,
  selectedTenantIds,
  handleApply,
}) {
  const [localSelectedIds, setLocalSelectedIds] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (show) {
      setLocalSelectedIds(selectedTenantIds || []);
      setSearchQuery("");
    }
  }, [show, selectedTenantIds]);

  if (!show) {
    return null;
  }

  const handleTenantChange = (tenantId) => {
    setLocalSelectedIds((prevIds) =>
      prevIds.includes(tenantId)
        ? prevIds.filter((id) => id !== tenantId)
        : [...prevIds, tenantId]
    );
  };

  const handleApplyClick = () => {
    handleApply(localSelectedIds);
    handleClose();
  };

  const primaryTenants = (tenantData || []).filter(
    (tenant) => tenant.is_primary === true
  );

  const filteredTenants = primaryTenants.filter((tenant) => {
    const searchLower = searchQuery.toLowerCase();
    const fullName =
      `${tenant.first_name || ""} ${tenant.last_name || ""}`.toLowerCase();
    const buildingNameLower = (tenant.building_name || "").toLowerCase();
    const mobileLower = (tenant.mobile || "").toLowerCase();

    return (
      fullName.includes(searchLower) ||
      buildingNameLower.includes(searchLower) ||
      mobileLower.includes(searchLower)
    );
  });

  const handleSelectAll = () => {
    setLocalSelectedIds(filteredTenants.map((tenant) => tenant.entity_id));
  };

  const handleClearAll = () => {
    setLocalSelectedIds([]);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      {/* 🔥 MODAL CONTAINER: Increased width on larger screens */}
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm md:max-w-2xl lg:max-w-4xl max-h-[85vh] flex flex-col transition-all duration-300">
        {/* 🔥 HEADER: Increased padding and font size */}
        <div className="flex-shrink-0 flex items-center justify-between p-5 md:p-6 border-b border-gray-200">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800">
            Select Tenants
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <IoIosCloseCircleOutline size={30} />
          </button>
        </div>

        {/* Search & Actions Bar */}
        <div className="flex-shrink-0 p-5 border-b border-gray-200 bg-gray-50 space-y-4">
          <input
            type="text"
            placeholder="Search by name, building, or mobile..."
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-base"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600 font-medium">
              {localSelectedIds.length} selected
            </span>
            <div className="flex gap-4">
              <button
                onClick={handleSelectAll}
                className="text-sm text-blue-600 hover:underline font-semibold"
              >
                Select All Visible
              </button>
              <button
                onClick={handleClearAll}
                className="text-sm text-red-600 hover:underline font-semibold"
              >
                Clear All
              </button>
            </div>
          </div>
        </div>

        {/* 🔥 SCROLLABLE CONTENT: Increased padding and responsive grid */}
        <div className="flex-1 overflow-y-auto p-5 md:p-6">
          {filteredTenants.length > 0 ? (
            // 🔥 RESPONSIVE GRID: Uses more columns on larger screens
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredTenants.map((tenant) => {
                const isSelected = localSelectedIds.includes(tenant.entity_id);
                return (
                  <label
                    key={tenant.entity_id}
                    // 🔥 CARD STYLING: Clearer visual feedback on selection and hover
                    className={`flex items-center p-4 rounded-lg border-2 cursor-pointer transition-all duration-200
                                ${
                                  isSelected
                                    ? "bg-blue-50 border-blue-500 shadow-md"
                                    : "bg-white border-gray-200 hover:border-blue-400 hover:shadow-sm"
                                }`}
                  >
                    <CircularInitial name={tenant.first_name} />
                    <div className="ml-4 flex-1">
                      <div className="font-semibold text-gray-900 leading-tight">
                        {tenant.first_name} {tenant.last_name}
                      </div>
                      <div className="text-sm text-gray-500 mt-1">
                        {tenant.building_name}
                      </div>
                    </div>
                    <input
                      type="checkbox"
                      className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 shrink-0 ml-2"
                      checked={isSelected}
                      // readOnly // The entire label is clickable, so the checkbox is just for show
                      onChange={() => handleTenantChange(tenant.entity_id)}
                    />
                  </label>
                );
              })}
            </div>
          ) : (
            // "No results" message styling improved
            <div className="flex flex-col items-center justify-center py-16 text-gray-500 text-center">
              <FaUsers className="w-16 h-16 mb-5 text-gray-300" />
              <p className="font-semibold text-lg text-gray-600">
                {searchQuery ? "No Tenants Found" : "No Tenants Available"}
              </p>
              <p className="text-sm mt-1">
                {searchQuery
                  ? "Try adjusting your search terms."
                  : "Primary tenants will appear here once added."}
              </p>
            </div>
          )}
        </div>

        {/* 🔥 FOOTER: Made buttons larger and more distinct */}
        <div className="flex-shrink-0 p-5 border-t border-gray-200 bg-gray-50">
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleClose}
              className="w-full sm:w-auto flex-1 px-6 py-3 text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 font-semibold transition-colors text-base"
            >
              Cancel
            </button>
            <button
              onClick={handleApplyClick}
              className="w-full sm:w-auto flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold transition-colors disabled:opacity-60 disabled:cursor-not-allowed text-base"
            >
              Apply Selection ({localSelectedIds.length})
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TenantModal;
